var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBathroomRenovations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1277 9H9.87211C9.66644 9 9.5 9.16643 9.5 9.37211V38.6277C9.5 38.8334 9.66643 38.9998 9.87211 38.9998H29.4351C29.6408 38.9998 29.8072 38.8334 29.8072 38.6277V37.1393C29.8072 36.9337 29.6408 36.7672 29.4351 36.7672H18.3437C18.138 36.7672 17.9716 36.9336 17.9716 37.1393V38.2556L10.2439 38.257V34.5751H11.8852C12.3371 34.5751 12.7268 34.3045 12.9027 33.9175H16.3516C18.066 33.9175 19.461 32.5225 19.461 30.8081V30.2642C19.461 28.5498 18.066 27.1547 16.3516 27.1547H12.9027C12.7268 26.7677 12.3384 26.4971 11.8852 26.4971H10.2439V9.74451H11.7932V11.8283C11.7932 13.1624 12.3249 14.2314 13.3303 14.9201C14.1949 15.5128 15.4154 15.8267 16.8603 15.8267C18.3054 15.8267 19.5259 15.5128 20.3903 14.9201C21.3956 14.23 21.9274 13.1611 21.9274 11.8283L21.9247 9.74451H23.6458V16.8037C23.6458 17.3002 23.8393 17.7684 24.1911 18.1189L30.3814 24.3091C30.7332 24.661 31.2 24.8545 31.6966 24.8545H38.7558V38.2557H36.8777V38.9999H39.1279C39.3336 38.9999 39.5 38.8335 39.5 38.6278V9.37222C39.5 9.16655 39.3336 9.00011 39.1279 9.00011L39.1277 9ZM18.7149 37.512H29.0619V38.2562H18.7149V37.512ZM13.0023 27.8982H16.3514C17.6557 27.8982 18.7166 28.959 18.7166 30.2634V30.8074C18.7166 32.1118 17.6557 33.1726 16.3514 33.1726L13.0023 33.1712V27.8982ZM11.886 27.2406C12.0917 27.2406 12.2581 27.4071 12.2581 27.6127V33.4581C12.2581 33.6638 12.0917 33.8302 11.886 33.8302H10.2434V27.2407L11.886 27.2406ZM16.3906 9.74385H17.3255V11.4744H16.3906V9.74385ZM16.0184 12.2186H17.699C17.9047 12.2186 18.0711 12.0522 18.0711 11.8465V11.2322H19.6921V11.8276C19.6921 12.5853 19.4201 12.8762 19.1251 13.0792C18.6407 13.4107 17.8356 13.5947 16.8587 13.5947C15.8804 13.5947 15.0753 13.412 14.5923 13.0792C14.2973 12.8776 14.0253 12.5867 14.0253 11.8276V11.2322H15.6463V11.8465C15.6463 12.0522 15.8128 12.2186 16.0184 12.2186ZM21.1802 11.8276C21.1802 14.6596 18.4727 15.0816 16.8584 15.0816C15.2441 15.0816 12.5366 14.6595 12.5366 11.8276V9.74382H15.6461V10.488H13.653C13.4473 10.488 13.2809 10.6544 13.2809 10.8601V11.8276C13.2809 12.952 13.7883 13.431 14.1712 13.6922C14.7774 14.1089 15.7327 14.3376 16.8584 14.3376C17.9856 14.3376 18.9395 14.1089 19.5457 13.6922C19.9273 13.4297 20.436 12.952 20.436 11.8276V10.8601C20.436 10.6544 20.2696 10.488 20.0639 10.488H18.0708V9.74382H21.1802V11.8276ZM38.7555 24.1095H31.6964C31.3987 24.1095 31.1173 23.9931 30.9075 23.782L24.7172 17.5917C24.5062 17.3806 24.3898 17.1005 24.3898 16.8029V9.7437H38.7558L38.7555 24.1095Z",
    fill: "url(#paint0_linear_2173_8553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9958 22.8207C31.3476 23.1726 31.8144 23.3661 32.311 23.3661H36.1496C37.1752 23.3661 38.0101 22.5312 38.0101 21.5056V13.0935C38.0101 11.6578 36.841 10.4888 35.4054 10.4888H26.9933C25.9677 10.4888 25.1328 11.3236 25.1328 12.3493V16.1879C25.1328 16.6844 25.3263 17.1526 25.6781 17.503L30.9958 22.8207ZM25.8773 12.3479C25.8773 11.7323 26.378 11.2316 26.9936 11.2316H35.4057C36.4314 11.2316 37.2662 12.0665 37.2662 13.0921V21.5042C37.2662 22.1199 36.7656 22.6205 36.1499 22.6205H32.3113C32.0137 22.6205 31.7322 22.5041 31.5225 22.293L26.2037 16.9742C25.9926 16.7631 25.8762 16.483 25.8762 16.1854L25.8773 12.3479Z",
    fill: "url(#paint1_linear_2173_8553)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6385 15.2752C35.7115 15.3483 35.8063 15.3848 35.901 15.3848C35.9957 15.3848 36.0918 15.3483 36.1635 15.2752C36.974 14.4647 36.974 13.1455 36.1635 12.3335C35.7711 11.9411 35.2488 11.7246 34.6927 11.7246C34.1366 11.7246 33.6143 11.9411 33.2219 12.3335C33.0771 12.4783 33.0771 12.7151 33.2219 12.8598L35.6385 15.2752ZM34.694 12.4689C35.0512 12.4689 35.3868 12.6083 35.6385 12.86C35.8902 13.1116 36.0295 13.4472 36.0295 13.8044C36.0295 14.0331 35.9727 14.2536 35.8644 14.4485L34.05 12.634C34.2448 12.5258 34.4654 12.4689 34.694 12.4689Z",
    fill: "url(#paint2_linear_2173_8553)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 16.2114L27.4013 15.6851L32.8166 21.1003L32.2902 21.6266L26.875 16.2114Z",
    fill: "url(#paint3_linear_2173_8553)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9297 13.7798L27.456 13.2534L35.2429 21.0403L34.7166 21.5666L26.9297 13.7798Z",
    fill: "url(#paint4_linear_2173_8553)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1758 12.5371L28.7021 12.0107L36.489 19.7976L35.9626 20.324L28.1758 12.5371Z",
    fill: "url(#paint5_linear_2173_8553)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6055 12.4785L31.1318 11.9521L36.5471 17.3674L36.0207 17.8937L30.6055 12.4785Z",
    fill: "url(#paint6_linear_2173_8553)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_8553",
    x1: 9.5,
    y1: 24,
    x2: 39.5,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2173_8553",
    x1: 25.1328,
    y1: 16.9274,
    x2: 38.0101,
    y2: 16.9274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2173_8553",
    x1: 33.1133,
    y1: 13.5547,
    x2: 36.7713,
    y2: 13.5547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2173_8553",
    x1: 26.875,
    y1: 18.6559,
    x2: 32.8166,
    y2: 18.6559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2173_8553",
    x1: 26.9297,
    y1: 17.41,
    x2: 35.2429,
    y2: 17.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2173_8553",
    x1: 28.1758,
    y1: 16.1673,
    x2: 36.489,
    y2: 16.1673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2173_8553",
    x1: 30.6055,
    y1: 14.9229,
    x2: 36.5471,
    y2: 14.9229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroomRenovations);
export default __webpack_public_path__ + "static/media/Bathroom Renovations.ed999e01aa75c553abcc009b9a5540bf.svg";
export { ForwardRef as ReactComponent };